(ns app.front.view.admin.migration.link-primary-addresses
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/link-primary-addresses
    :title     "Link primary addresses to property addresses"
    :help-text (str "This migration adds the primary address of each property to its address collection unless it is "
                    "already there.\n"
                    "If the migration fails, resolve the reported error and run it again to process remaining properties.\n"
                    "The property index in Elasticsearch is not updated by this migration. "
                    "Once the migration has been checked, reindex the property index using the admin tools.")}
   match])

(def route
  {:name        :view/admin.migration.link-primary-addresses
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/link-primary-addresses]))}]})
